module.exports = __webpack_public_path__ + "img/Menu-05.ada7f87b.png";